import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Router } from '@angular/router';
import { filter, Subject } from 'rxjs';
import { AuthEvent, AuthService } from '@michelin/auth';

export const THOUSAND = 1000;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationWrapperService {
  endpoint = 'authentication/authorize';
  onLoginRequired$ = new Subject<void>();
  onLoginSuccess$ = new Subject<User>();
  onLogoutSuccess$ = new Subject<void>();
  onSessionExpired$ = new Subject<void>();

  /**
   * Constructor
   *
   * @param authService authService
   * @param userService userService
   */
  constructor(private readonly authService: AuthService) {
    if (this.isAuthenticated()) {
      //TODO Check if user has habilitation and push habilitation if not existing !
    }
  }

  /**
   * Logout
   */
  public logout(router: Router): void {
    sessionStorage.setItem('logoutRedirectTo', router.url);
    sessionStorage.removeItem('logged');
    this.authService.logOut();
  }

  /**
   * Get the user token
   */
  public getToken(): string {
    return this.authService.getIdToken();
  }

  /**
   * Si l'utilisateur est authentifié
   */
  public isAuthenticated(): boolean {
    return this.authService.hasValidAccessToken();
  }
}
